import React, { useState, useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Card, Row, Col, Spinner, Badge } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { getDriverDetail } from "../../../../api/driver";
import { FileUpload } from "../../../../components";
import dayjs from "dayjs";

const DriverIC = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const [detail, setDetail] = useState({});
    const [loading, setLoading] = useState(true);
    const form = useForm();

    const getData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await getDriverDetail(id);
            setDetail(response);

            // Set form values for file uploads
            if (response.icFront) {
                form.setValue("icFront", response.icFront);
            }
            if (response.icBack) {
                form.setValue("icBack", response.icBack);
            }
            if (response.selfie) {
                form.setValue("selfie", response.selfie);
            }
        } catch (error) {
            console.error("Error fetching driver details:", error);
        } finally {
            setLoading(false);
        }
    }, [id, form]);

    useEffect(() => {
        getData();
    }, [getData]);

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">{t("LOADING")}</span>
                </Spinner>
            </div>
        );
    }

    return (
        <FormProvider {...form}>
            <Row>
                <Col lg={4} md={6} className="mb-4">
                    <FileUpload
                        label={t("IC_FRONT")}
                        name="icFront"
                        readOnly={true}
                        fileName={detail.icFront?.originalName || detail.icFront?.name}
                        uploadProps={{
                            className: "w-100"
                        }}
                    />
                </Col>
                <Col lg={4} md={6} className="mb-4">
                    <FileUpload
                        label={t("IC_BACK")}
                        name="icBack"
                        readOnly={true}
                        fileName={detail.icBack?.originalName || detail.icBack?.name}
                    />
                </Col>
                <Col lg={4} md={6} className="mb-4">
                    <FileUpload
                        label={t("SELFIE")}
                        name="selfie"
                        readOnly={true}
                        fileName={detail.selfie?.originalName || detail.selfie?.name}
                    />
                </Col>
            </Row>
        </FormProvider >
    );
};

export default DriverIC;
